import React, { useCallback, useEffect, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import { useProperty } from "../../../components/property-provider";
import { useApiClient } from "../../../lib/http";
import MultiCheckboxGroup from "../../witadmin/CRUD/Common/MultiCheckBoxGroup";
import { WitLabel } from "./common";

export default function PromotionsMultiCheckbox({
  schema,
  formData,
  onChange,
  idSchema,
}: FieldProps) {
  const property = useProperty();
  const httpClient = useApiClient();

  const [promotions, setPromotions] = useState();

  useEffect(() => {
    if (!promotions) {
      async function fetchPromotions() {
        const response = await httpClient.get<any>(
          `/api/property/${property.ticker}/engine/administration/promo`
        );
        setPromotions(response);
      }
      fetchPromotions();
    }
  });

  const handleOnChange = useCallback(
    ({ value }) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <div id={idSchema.$id}>
      <WitLabel>{schema?.title}</WitLabel>
      <MultiCheckboxGroup
        className="witadmin-bs3"
        value={formData}
        field={{
          fieldName: `promotionsMultiCheckbox`,
          options: promotions || [],
        }}
        onChange={handleOnChange}
      />
    </div>
  );
}
